import React from 'react';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import useTranslate from '../../../../customHooks/useTranslate';
import { ChildrenAgeSegmentState } from '../../../../types/properties/propertyTypes';
import AgeRangeRow from './AgeRangeRow';

interface AgeRangesTableProps {
    segments: ChildrenAgeSegmentState[];
    adultAge: number;
    availableCount: number;
    canAddRange: boolean;
    disabled: boolean;
    onUpdateAge: (key: string, age: number) => void;
    onDeleteRange: (key: string) => void;
    onAddRange: () => void;
    onAgeBlur: () => void;
}

const AgeRangesTable = ({
    segments,
    adultAge,
    availableCount,
    canAddRange,
    disabled,
    onUpdateAge,
    onDeleteRange,
    onAddRange,
    onAgeBlur,
}: AgeRangesTableProps) => {
    const translate = useTranslate();
    let fromAge = 0;

    return (
        <>
            <TableContainer className=' overflow-auto border-color border-radius-4'>
                <Table size='small'>
                    <colgroup>
                        <col />
                        <col style={{ width: 100 }} />
                        <col style={{ width: 180 }} />
                        <col style={{ width: 64 }} />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <TableCell>{translate('age_segment')}</TableCell>
                            <TableCell className='text-align-center'>
                                {translate('from')}
                            </TableCell>
                            <TableCell className='text-align-center'>
                                {translate('up_to_exclusive')}
                            </TableCell>
                            <TableCell className='text-align-center'>
                                {translate('actions')}
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {segments.map((segment, index) => {
                            const rowFromAge = fromAge;
                            fromAge = segment.age;
                            return (
                                <AgeRangeRow
                                    adultAge={adultAge}
                                    canDelete={index === segments.length - 1}
                                    disabled={disabled}
                                    fromAge={rowFromAge}
                                    key={segment.key}
                                    nextAge={
                                        segments[index + 1]?.age ?? adultAge + 1
                                    }
                                    onDeleteRange={onDeleteRange}
                                    onAgeBlur={onAgeBlur}
                                    onUpdateAge={onUpdateAge}
                                    segment={segment}
                                />
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <div className='age-ranges-table__footer'>
                {canAddRange && (
                    <>
                        <Button
                            color='primary'
                            className='age-ranges-table__add-button'
                            disabled={disabled}
                            onClick={onAddRange}
                            variant='outlined'
                        >
                            {translate('add_age_range')}
                        </Button>

                        <span className='age-ranges-table__secondary-text'>{`${availableCount} ${translate(
                            availableCount === 1
                                ? 'age_range_available'
                                : 'age_ranges_available'
                        )}`}</span>
                    </>
                )}
            </div>
        </>
    );
};

export default AgeRangesTable;
